---
nb:
  labels:
    apply: Lagre
    clear: Tøm
    labels: Etiketter
